import { LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { ServerService } from './ServerService';
import { StartPageService } from './StartPageService';

export class SiteSwitchService {

  public static $inject = [
    '$location',
    '$q',
    'ServerService',
    'StartPageService',
  ];

  constructor(private $location: ng.ILocationService,
              private $q: ng.IQService,
              private server: ServerService,
              private startPageService: StartPageService,
  ) {}

  public static getSiteUrlFragment(urlName: string): string {
    return `/#/site/${urlName}/`;
  }

  /**
  * Switches the site if the given urlName if it's not the current site's urlName
  *
  * Use this instead of ServerService.switchSiteIfNeeded in order to give proper
  * feedback in the error conditions
  */
  public switchIfNeeded(urlName: string, podRedirectPath?: string): ng.IPromise<void> {
    if (podRedirectPath === undefined) {
      podRedirectPath = SiteSwitchService.getSiteUrlFragment(urlName);
    }

    return this.server.switchSiteIfNeeded_DoNotCallDirectly(urlName, podRedirectPath)
      .catch((error: IError) => {
        // This error code is returned when the current user doesn't have access to the site they're trying to switch to.
        // The user must log in using different credentials, specific to the site. For now, it is supported only when
        // third party auth is configured (i.e. SiteSAML is enabled).
        if (error && error.code === CommonErrorCode.SiteUserNotFound && this.server.isSiteSamlEnabled()) {
          LoginUrlsWrapper.navigateToSignIn({
            site: urlName
          });
        } else {
          LoginUrlsWrapper.navigateToSignInErrorCodeFromSiteSwitch('' + error.code);
        }
        return this.$q.reject(error);
      });
  }

  public switchIfNeededAndRedirectToStartPage(urlName: string, podRedirectPath?: string): ng.IPromise<void> {
    return this.switchIfNeeded(urlName, podRedirectPath).then(() => {
      this.$location.url(this.startPageService.getCurrentUserStartPageForCurrentSite());
    });
  }

  public switchIfNeededNoFeedback(urlName: string): ng.IPromise<void> {
    return this.server.switchSiteIfNeeded_DoNotCallDirectly(urlName);
  }
}

Module.instance().service('SiteSwitchService', SiteSwitchService);
